module.exports = __webpack_public_path__ + "static/media/arrow-circle-empty-medium.e5bc558d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-empty-medium.svg
// module id = 85
// module chunks = 0